var _module_exports = "\n<tb-audit-log-table class=\"md-whiteframe-z1\" flex audit-log-mode=\"{{vm.types.auditLogMode.tenant}}\" page-mode=\"true\">\n</tb-audit-log-table>\n";;
var path = '/audit/audit-logs.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;